
import { useState } from 'react'

export function getPageInfo() {
    let room, admin;
    let path = document.location.pathname;
    if (path.indexOf("/r/") != 0) {
        throw new Error("Unknown path")
    }
    path = path.substr(3)
    let components = path.split("/")
    if (components.length == 1) {
        return { room_id: components[0], admin: false }
    }
    if (components.length == 2 && components[1] == "admin") {
        return { room_id: components[0], admin: true }
    }
    throw new Error("Unkown path")
}

export function usePageInfo() {
    return [pageInfo, setPageInfo] = useState(() => getPageInfo())
}